<nav
  class="w-full border-b flex items-center sticky z-[50] shadow-sm top-0 bg-white dark:border-surface-700 dark:bg-surface-900"
>
  <div class="p-4 flex-wrap flex items-center justify-between gap-4 w-full">
    <div class="flex items-center gap-4">
      <p-button
        (click)="toggleSidebar()"
        severity="secondary"
        [icon]="icons.bars"
        aria-label="menu"
      />
      <div id="header" class="flex justify-center items-center gap-3">
        <img src="police-logo.svg" width="40" height="40" alt="Police Logo" />
        <img src="rieaya-logo.svg" width="40" height="40" alt="Rieaya Logo" />
      </div>
      <div>
        <p-breadcrumb
          class="max-w-full text-sm"
          [model]="items"
          [home]="userData.role === LAUNDRY_MANAGER ? home : undefined"
        >
          <!-- Breadcrumb items -->
          <ng-template #item let-item>
            @if (item.routerLink) {

            <a
              [routerLink]="formatRouterLink(item.routerLink)"
              class="p-breadcrumb-item-link"
            >
              <span
                [ngClass]="[item.icon ? item.icon : '', 'text-color']"
              ></span>
              <span class="font-medium">{{ item.label | transloco }}</span>
            </a>

            }
          </ng-template>

          <!-- Home icon / item -->
          <ng-template pTemplate="home" let-item>
            <a [routerLink]="item.routerLink" class="p-breadcrumb-home-link">
              <i [class]="icons.home"></i>
            </a>
          </ng-template>
        </p-breadcrumb>
      </div>
    </div>
    <div class="flex items-center gap-6 lg:gap-4">
      <rieaya-language-picker
        [lang]="LANG"
        defaultLang="en"
      ></rieaya-language-picker>
      <app-notifications class="ms-4"></app-notifications>
      <app-user-avatar></app-user-avatar>
    </div>
  </div>
</nav>
@if (isMenuOpen) {
<div
  (click)="toggleSidebar()"
  class="fixed z-50 top-0 w-[100svw] h-[100svh] bg-black/30"
></div>
}
